import { Snackbar, Alert } from '@mui/material';
import { TableTitleBox, PaginationTable, LoadingSkeleton } from '../common/components';
import AnniversaryPlanFilters from './components/AnniversaryPlanFilters';
import AnniversaryPlanSummaryTable from './components/AnniversaryPlanSummaryTable';
import AnniversaryPlanInstallmentsDialog from './components/AnniversaryPlanInstallmentsDialog';
import { useAnniversaryPlanFeature } from './hooks/useAnniversaryPlanFeature';

const AnniversaryPlan = () => {
  const {
    results,
    total,
    totalPages,
    isLoading,
    page,
    rowsPerPage,
    pendingFilters,
    installmentsData,
    installmentsLoading,
    installmentsDialogOpen,
    selectedContract,
    syncLoading,
    snackbar,
    handleFilterChange,
    handleSearch,
    handlePageChange,
    handleRowsPerPageChange,
    handleRowClick,
    handleCloseInstallmentsDialog,
    handleSync,
    handleCloseSnackbar,
  } = useAnniversaryPlanFeature();

  if (isLoading) {
    return <LoadingSkeleton />;
  }

  return (
    <>
      <TableTitleBox title="Plan Aniversario | Habitat" />

      <AnniversaryPlanFilters
        pendingFilters={pendingFilters}
        onFilterChange={handleFilterChange}
        onSearch={handleSearch}
        onSync={handleSync}
        isLoading={isLoading}
        syncLoading={syncLoading}
      />

      <AnniversaryPlanSummaryTable
        rows={results}
        isLoading={isLoading}
        onRowClick={handleRowClick}
      />

      <PaginationTable
        totalPages={totalPages}
        totalCount={total}
        page={page}
        onPageChange={handlePageChange}
        rowsPerPage={rowsPerPage}
        onRowsPerPageChange={handleRowsPerPageChange}
      />

      <AnniversaryPlanInstallmentsDialog
        open={installmentsDialogOpen}
        onClose={handleCloseInstallmentsDialog}
        contractNumber={selectedContract?.contract_number}
        agreementInstallments={selectedContract?.agreement_installments}
        installmentsData={installmentsData}
        isLoading={installmentsLoading}
      />

      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert onClose={handleCloseSnackbar} severity={snackbar.severity} sx={{ width: '100%' }}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </>
  );
};

export default AnniversaryPlan;
